import {
  ArrowDownOutlined,
  ClockCircleOutlined,
  FileOutlined,
} from '@ant-design/icons';
import { selectEmailAnalytics } from '@mm/state/selectors/botAnalyticsSelector';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  calculateGrowth,
  StatBox,
} from '../../EmailAnalytics/EmailSummaryStats';
import { ReactComponent as ClickedIcon } from 'assets/click.svg';
import styles from './XRayAnalyticsAvgSummary.module.css';

export const XRayAnalyticsAvgSummary = () => {
  const emailAnalytics = useSelector(selectEmailAnalytics);
  const summaryStats = emailAnalytics?.summary?.stats;
  const currentStat = summaryStats?.[0]?.current;
  const prevStat = summaryStats?.[0]?.previous;
  const hide = true;

  if (hide) {
    return null;
  }

  return (
    <div className={styles.statsContainer}>
      <StatBox
        className={styles.box}
        label="Avg. Page Views"
        icon={<FileOutlined className={styles.icon} />}
        stat={currentStat?.leads ? currentStat?.leads.toString() : '0'}
      />
      <StatBox
        className={styles.box}
        label="Avg. Time on Website"
        icon={<ClockCircleOutlined className={styles.icon} />}
        stat={currentStat?.sent ? currentStat?.sent.toString() : '0'}
        growth={calculateGrowth(currentStat?.sent, prevStat?.sent)}
      />
      <StatBox
        className={styles.box}
        label="Avg. Scroll Depth"
        icon={<ArrowDownOutlined className={styles.icon} />}
        stat={currentStat?.open?.toString() || ''}
        growth={calculateGrowth(currentStat?.open, prevStat?.open)}
      />
      <StatBox
        className={styles.box}
        label="Avg. Clicks During Session"
        icon={<ClickedIcon className={styles.icon} />}
        stat={currentStat?.click?.toString() || ''}
        growth={calculateGrowth(currentStat?.click, prevStat?.click)}
      />
    </div>
  );
};
